// removed by extract-text-webpack-plugin
module.exports = {"livePreview":"style__livePreview___e9XTw","directionsList":"style__directionsList___3MYM-","ingredientsList":"style__ingredientsList___3zSC6","name":"style__name___3qoom","img":"style__img___VaXe2"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/livePreview/style.scss
 ** module id = 364
 ** module chunks = 0
 **/